import { NewOrderAgentInfo } from '@helpers/new-order-loader';

export const showBuyerPay = (
  isBuyerPayFeatureEnabled: boolean,
  { agentRepresents = {}, isRealtorOwned = false }: NewOrderAgentInfo = {},
): boolean => {
  return isBuyerPayFeatureEnabled && !agentRepresents?.seller && !isRealtorOwned;
};

export const resetBuyerPay = (
  isBuyerPay: boolean,
  isBuyerPayFeatureEnabled: boolean,
  { agentRepresents = {}, isRealtorOwned = false }: NewOrderAgentInfo = {},
): boolean => {
  return !!(isBuyerPay && (!isBuyerPayFeatureEnabled || agentRepresents?.seller || isRealtorOwned));
};
